/* eslint-disable vue/no-parsing-error */
<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div :class="['IM_4_' + this.id]">
    <div class="background">
      <div class="background-dodo">
        <div class="bulle">
          <div class="cadre">
            <p>
              Pfiou... je suis naze moi... et l'air de la Troposphère est si agréable que - oohaaah- je crois que je ne
              vais pas tarder à m'endorm... ZZzzzz
            </p>
          </div>
        </div>
        <div class="bouton actions">
          <a class="button btn btn-secondary" href="https://view.genial.ly/5fde62d4a666f40d7dc6225c">
            Reprendre&nbsp;l'aventure
          </a>
          <NextButton class="button next" url="/immersion04/3" text="Rejoindre le rêve d'Erwin" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NextButton from "@/components/NextButton.vue";

export default {
  name: "IM_4_2",
  components: { NextButton },
  data: function () {
    return {
      id: 2
    };
  }
};
</script>

<style scoped lang="scss">
.background {
  width: 100vw;
  height: calc(100vh - 60px);
  position: relative;
  top: 0;
  right: 0;
  background-image: url(https://cdn.exploreve.fr/content/IM3/images/jeu_ballon/interfaces/fond_conclusion_v1.svg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.background-dodo {
  width: 90vw;
  height: calc(100vh - 60px);
  position: absolute;
  top: 0;
  left: 5vw;
  background-image: url(https://cdn.exploreve.fr/content/IM4/dodo.webp);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  z-index: 50;
}
.bouton {
  position: absolute;
  width: 800px;
  bottom: 5vh;
  right: calc(50vw - 400px);
  z-index: 9999;
}

.next {
  height: 100%;

  & > .box {
    height: 100% !important;
    vertical-align: middle;
    display: flex;
    margin: 7px 40px;
    justify-content: center;
    align-items: center;
  }
}

.cadre {
  position: absolute;
  background-color: white;
  width: 30vw;
  border-radius: 15px;
  text-align: left;
  padding: 10px;
  z-index: 10;
  p {
    margin-bottom: 0 !important;
    font-family: Faune;
    font-style: normal;
    font-weight: normal;
    font-size: 3vh;
    line-height: 4vh;
  }
}
.bulle {
  position: absolute;
  top: 30vh;
  left: 15vw;
  & .cadre::after {
    content: "";
    position: absolute;
    top: 100%;
    right: 10%;
    width: 0;
    height: 0;
    border-left: 2.5vh solid transparent;
    border-right: 2.5vh solid transparent;
    border-top: 7vh solid white;
  }
}

.actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

a.button {
  color: white !important;
  text-decoration: none !important;
  font-size: 26px;
  line-height: 35px !important;
  width: 400px;
  border-radius: 5px;
  background-color: #5e2a57;
  margin: auto;
  cursor: pointer;
  text-align: center;
  vertical-align: middle;
  &:hover {
    background-color: #3b1a36;
    border-color: #32162e;
  }
}
</style>
